import { PlanInterface } from '../../../models/plan.model';
import { Component, inject, signal } from '@angular/core';
import { CrudEditComponent } from '../../../shared/components/crud/edit/edit.component';
import { ActivatedRoute } from '@angular/router';
import { PLANES_FIELDS_FORM } from '../../../constants/planes.constants';
import { PlanesService } from '../../../core/planes.service';
import { NivelService } from '../../../core/nivel.service';
import { ModalidadService } from '../../../core/modalidad.service';

@Component({
  selector: 'app-planes-edit',
  imports: [CrudEditComponent],
  templateUrl: './edit.html',
  styleUrls: ['./edit.scss']
})
export class PlanesEditComponent {
  id = signal('');
  fields = PLANES_FIELDS_FORM;
  planesService = new PlanesService;
  nivelService = new NivelService;
  modalidadService = new ModalidadService;
  plan!: PlanInterface;
  private activatedRoute = inject(ActivatedRoute);
  constructor() {
    this.activatedRoute.params.subscribe((params) => {
      this.id.set(params['id']);
    });
  }
  ngOnInit() {
    this.planesService.getById(Number(this.id())).subscribe((data) => {
      this.plan = <PlanInterface>data;
    });
    this.nivelService.getAllForSelect().subscribe((data) => {
      if (this.fields['nivel_id']) this.fields['nivel_id'].options = data;
    });
    this.modalidadService.getAllForSelect().subscribe((data) => {
      if (this.fields['modalidad_id']) this.fields['modalidad_id'].options = data;
    });
  }
}
